import React from "react";
import Header from "../header/Header";
import "./Hero.css";
import hero_img from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";
import heart from "../../assets/heart.png";
import calories from "../../assets/calories.png";
import { motion } from "framer-motion";
import { type } from "@testing-library/user-event/dist/type";
import NumberCounter from 'number-counter'
const Hero = () => {
  const transition={type:'spring', duration:3}
  const mobile=window.innerWidth<=768? true :false;
  return (
    <div className="main-hero" id="Home">
      <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header />
        <div className="the-best-add">
          <motion.div
          initial={{left:mobile? "173px" :'238px'}}
          whileInView={{left:'10px'}}
          transition={{...transition,type:'tween'}}></motion.div>
          {/* <div></div> */}
          <span>The Best Fitness Club in The Town</span>
        </div>
        <div className="hero-text">
          <div>
            <span className="stroke-text">Shape </span>
            <span>Your</span>
          </div>
          <div>
            <span>Idle Body</span>
          </div>
          <div>
            <span>
              In here we will help you to shape and build your body and live up
              your life to fullest
            </span>
          </div>
        </div>
        <div className="figure">
          <div>
            
            <span><NumberCounter start={100} end={140} delay='4' preFix="+"/></span>
            <span>EXPERT COACHES</span>
          </div>
          <div>
            <span><NumberCounter start={900} end={978} delay='4' preFix="+"/></span>
            <span>MEMBERS JOINED</span>
          </div>
          <div>
            <span><NumberCounter start={1} end={50} delay='4' preFix="+"/></span>
            <span>FITNESS PROGRAMS</span>
          </div>
        </div>
        <div className="hero-btn">
          <button className="btn">Get Started</button>
          <button className="btn">Learn More</button>
        </div>
      </div>
      <div className="right-h">
        <button className="btn">Join Now</button>
        <motion.div className="heart-rate"
        initial={{right:"-1rem"}}
        whileInView={{right:"4rem"}}
        transition={transition}>
          <img src={heart} alt="" />
          <span>Heart</span>
          <span>116 bpm</span>
        </motion.div>
        <motion.img
        initial={{right:"11rem"}}
        whileInView={{right:"20rem"}}
        transition={transition}
          src={hero_image_back}
          alt=""
          srcset=""
          className="hero-image-back"
        />
        <img src={hero_img} alt="" srcset="" className="hero-image" />
      <motion.div className="caloreis"
      initial={{right:"37rem"}}
      whileInView={{right:"28rem"}}
      transition={transition}>
        <img src={calories} alt="" srcset="" />
        <div>
        <span>Caloreis Burned</span>
        <span>220 Kcal</span>
        </div>

      </motion.div>
      </div>
    </div>
  );
};

export default Hero;
